/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetTransactionTypesResponseJson } from './get-transaction-types-response-json';
import { GetTransactionTypesResult } from '../results/get-transaction-types-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { TransactionTypeDto } from '../models/transaction-type-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetTransactionTypesResponse extends ResponseWithErrorGeneric<GetTransactionTypesResponseJson, GetTransactionTypesResult> implements IResponseWithErrorGeneric<GetTransactionTypesResult> {
  public transactionTypes: TransactionTypeDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetTransactionTypesResponse>) {
    super(response, GetTransactionTypesResult.Error);
    if (this.result !== GetTransactionTypesResult.Success) {
      return;
    }

    if (this.body.transactionTypes != null)
      this.transactionTypes = this.body.transactionTypes;
  }
  //</custom-body>
}
